export const getTargetBIN = (number = '', source = []) => source.find((b) => number.startsWith(b?.bin));
